import privateApi from './private';
import business from './business';

export default {
	private: privateApi,
	business,
};
